import React from 'react';
import { Alert, Button, Spinner } from '@themesberg/react-bootstrap';

export default function RecordEditFeedback({ loading, error, label, onRetry, onCancel }) {
  return (
    <>
      {loading ? (
        <div role="status" className="d-flex align-items-center gap-2 py-4">
          <Spinner animation="border" size="sm" aria-hidden="true" />
          Loading {label} details...
        </div>
      ) : (
        <Alert variant="danger">
          {error || 'Unable to load ' + label + ' details. Please try again.'}
          <Button variant="link" type="button" onClick={onRetry}>Retry</Button>
        </Alert>
      )}
      {onCancel && (
        <div className="create-record-form__actions d-flex justify-content-end gap-2 mt-2">
          <Button variant="outline-secondary" type="button" onClick={onCancel}>Cancel</Button>
        </div>
      )}
    </>
  );
}
